import styled from 'styled-components';

import MdIcon from '../mdIcon';

export const Container = styled.div`
  z-index: 100;
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 759px) {
    flex: 1;
  }
`;

export const Content = styled.div`
  text-align: center;
  background: #fff;
  max-height: calc(100% - 60px);
  overflow: auto;
  max-width: calc(100% - 8rem);
  min-width: 20%;
  width: ${(props) => props.widthContainer};
  height: ${(props) => props.heightContainer};
  padding: 20px;
  border-radius: 6px;
  position: relative;
  -webkit-overflow-scrolling: touch;
  overflow: ${(props) => {
    if (props.isPdfShowing) return 'scroll';
    if (props.overflow) return props.overflow;
    return null;
  }};

  @media (max-width: 759px) {
    width: 100%;
    height: 100%;
    max-height: 100%;
    max-width: 100%;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 30px 0;
`;

export const IconContainer = styled.div`
  display: flex;
  cursor: pointer;
  justify-content: flex-end;
  position: absolute;
  right: 0;
  margin-right: 10px;
`;

export const StyledIcon = styled(MdIcon)`
  position: absolute;
  top: 16px;
  right: 16px;
`;

export const CloseContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export const Title = styled.span`
  text-align: left;
  font-size: 20px;
  letter-spacing: 0px;
  color: #262b45;
  opacity: 1;
  font-weight: 500;
`;

export const TabsPdfsContainer = styled.div`
  display: flex;
  overflow: auto;
  z-index: 999;
  flex: 1;
  border-top: 1px solid ${(props) => props.theme.palette.gray4};
  border-bottom: 1px solid ${(props) => props.theme.palette.gray4};
  top: 64px;
  background: #fff;
  z-index: 999;
  width: 100%;
`;

export const TabsPdfsItem = styled.div`
  cursor: pointer;
  display: flex;
  height: 50px;
  font-size: 14px;
  font-weight: 700;
  color: ${(props) =>
    props.isEnabled ? props.theme.palette.gray2 : props.theme.palette.gray3};
  border-bottom: 3px solid
    ${(props) =>
      props.isEnabled
        ? props.theme.palette.primary.contrastText
        : props.theme.palette.primary.main};
  text-transform: uppercase;
  width: 150px;
  min-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 10px;
  align-items: center;
  justify-content: center;
  border-right: 1px solid ${(props) => props.theme.palette.gray4};
  :nth-last-child(1) {
    min-width: ${(props) => props.itensQt > 2 && '200px'};
    padding-right: ${(props) => props.itensQt > 2 && '60px'};
  }
`;

export const ContentPdfChildren = styled.div`
  -webkit-overflow-scrolling: touch;
  padding-top: ${(props) => (props.isPdfShowing ? '115px' : 'unset')};
  padding-bottom: ${(props) => (props.isPdfShowing ? '175px' : 'unset')};
  @media (min-width: 800px) {
    padding-bottom: ${(props) => (props.isPdfShowing ? '10px' : 'unset')};
  }
`;
